
import { defineComponent, PropType, ref } from 'vue'
import { EmployeeModel, GivPasswordPayload, useEmployeeModule } from '@/modules/employees'
import QForm from 'quasar/src/components/form/QForm.js';
import EmployeeFormFieldRepeatPassword from '@/components/employees/form-fields/repeat-password.vue'
import EmployeeFormFieldPassword from '@/components/employees/form-fields/password.vue'
import { EmployeeRouteNames } from '@/router/routes-names'
import { useFormModule } from '@/modules/_shared/forms'

type AssignPasswordModel = Partial<GivPasswordPayload & { repeatPassword: string }>

function emptyModel (id: string): AssignPasswordModel {
    return {
        id,
        password: undefined,
        repeatPassword: undefined
    }
}

export default defineComponent({
    name: 'employees-assign-password-form',
    components: {
        EmployeeFormFieldPassword,
        EmployeeFormFieldRepeatPassword
    },
    props: {
        employee: {
            type: Object as PropType<EmployeeModel>,
            required: true
        }
    },
    setup (props, { emit }) {
        const { givePassword } = useEmployeeModule()
        const form = ref<QForm>()
        const employeeModel = ref(emptyModel(props.employee.id))
        const { createOnSuccess, submitForm } = useFormModule()
        const clearForm = () => {
            employeeModel.value = emptyModel(props.employee.id)
            if (form.value) {
                form.value.resetValidation()
            }
        }
        const emitEvent = () => emit('formSent')

        const sendRequest = async () => givePassword({
            id: employeeModel.value.id as string,
            password: employeeModel.value.password as string
        })

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess(`You've changed password for ${props.employee.firstName}`)
        ).then(clearForm).then(emitEvent)

        return {
            onSubmit,
            employeeModel,
            form,
            routesNames: EmployeeRouteNames
        }
    }
})
